import { FaExclamationTriangle, FaCrown, FaGift, FaNotesMedical } from "react-icons/fa";

export const PERMISSION_SCREENS = [
  {
    key: "Dashboard",
    label: "Dashboard Screen",
    actions: ["view", "edit", "delete"],
  },
  {
    key: "AiSummary",
    label: "AI Summary",
    actions: ["generate", "regenerate"],
  },
  {
    key: "ArrivalDeparture",
    label: "Arrivals & Departures",
    actions: ["view", "edit", "delete"],
  },

  {
    key: "Operations",
    label: "Daily Operations Screen",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    key: "Maintenance",
    label: "Maintenance Hub Screen",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    key: "InHouseGuests",
    label: "In-House Guests",
    actions: [
      "view",
      "edit",
      "delete",
      {
        key: "editRequests",
        label: "Manage Requests",
      },
    ],
  },
  {
    key: "Requests",
    label: "Requests Screen",
    actions: ["view", "create", "edit", "delete"],
  },
  {
    key: "HouseKeeping",
    label: "Housekeeping Hub",
    actions: ["view", "edit", "delete"],
  },
  {
    key: "Guests",
    label: "Guest Library",
    actions: ["view", "edit", "delete"],
  },
  {
    key: "SatisfactionForm",
    label: "Guest Satisfaction",
    actions: ["view", "create", "edit"],
  },
  {
    key: "Integrations",
    label: "Manage Integrations",
    actions: ["view", "edit", "delete"],
  },
];

export const SYSTEM_ROLES = {
  SUPER_ADMIN: {
    key: "superadmin",
    label: "Super Admin",
    power: 100,
  },

  ADMIN: {
    key: "admin",
    label: "Admin",
    power: 80,
  },

  HOUSEKEEPER: {
    key: "HouseKeeper",
    label: "Housekeeper",
    power: 50,
  },
};

export const MAX_HOTELS_PER_CLIENT = 5;

export const MAX_SECTIONS_PER_TEMPLATE = 20;

export const POWER_LEVELS = {
  SUPER_ADMIN: 100,
  ADMIN: 80,
  ROLE_USER: 50,
};

export const REQUEST_PRIORITY_CONFIG = {
  low: {
    label: "LOW PRIORITY",
    color: "#8A8A8A",
    border: "rgba(138,138,138,0.45)",
  },
  medium: {
    label: "MEDIUM PRIORITY",
    color: "#F5C542",
    border: "rgba(245,197,66,0.55)",
  },
  high: {
    label: "HIGH PRIORITY",
    color: "#FF5C5C",
    border: "rgba(255,92,92,0.6)",
  },
};

export const preferenceLabels = {
  arrival_time: "Arrival Time",
  parking_required: "Parking Required",
  has_pet: "Traveling with a Pet",
  room_temperature_f: "Room Temperature °F",
  sleep_preference: "Sleep Preference",
  concierge_engagement: "Concierge Engagement",
  culinary_preference: "Culinary Preference",
  morning_preference: "Morning Preference",
  evening_preference: "Evening Preference",
  neighborhood_experience: "Neighborhood Experience",
};

export const FLAG_CONFIG = {
  needs_attention: {
    label: "Needs Attention",
    icon: FaExclamationTriangle,
    color: "#FF4C4C", // red
  },
  vip_guest: {
    label: "VIP Guest",
    icon: FaCrown,
    color: "#916b04", // gold
  },
  celebration: {
    label: "Celebration",
    icon: FaGift,
    color: "#2c8f2f", // green
  },
  special_condition: {
    label: "Special Conditions",
    icon: FaNotesMedical,
    color: "#42A5F5", // blue
  },
};

export const FIELD_TYPES = [
  "Checkbox List",
  "Text Input",
  "Text Area",
  "Radio Buttons",
  "Bullet Point List",
  "Date Field",
  "Time Field",
];

export const TEMPLATE_FIELD_TYPES = [
  {
    label: "Checkbox List",
    value: "checkbox_list",
  },
  {
    label: "Text Input",
    value: "text_input",
  },
  {
    label: "Text Area",
    value: "text_area",
  },
  {
    label: "Radio Buttons",
    value: "radio_buttons",
  },
  {
    label: "Bullet Point List",
    value: "bullet_point_list",
  },
  {
    label: "Date Field",
    value: "date_field",
  },
  {
    label: "Time Field",
    value: "time_field",
  },
];

export const MAINTENANCE_TASK_CATEGORY_OPTIONS = [
  { label: "Cleaning", value: "cleaning" },
  { label: "Plumbing", value: "plumbing" },
  { label: "Electrical", value: "electrical" },
  { label: "HVAC", value: "hvac" },
  { label: "Landscaping", value: "landscaping" },
  { label: "General", value: "general" },
];

export const MAINTENANCE_TASK_PRIORITY_OPTIONS = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
  { label: "Urgent", value: "urgent" },
];

export const MAINTENANCE_TASK_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Scheduled", value: "scheduled" },
  { label: "In Progress", value: "in_progress" },
  { label: "Completed", value: "completed" },
];

export const DUMMY_WORKSPACE = {
  _id: "workspace_2026_01_31",

  templateId: "template_1",

  workspaceDate: "2026-01-31",

  sections: [
    {
      sectionTitle: "Departures",
      value: {
        items: [
          { text: "The Nest", completed: true },
          { text: "The Nook", completed: true },
          { text: "The Hideaway", completed: true },
          {
            text: "The Bluff | Late Check-Out - 1PM",
            completed: true,
          },
          { text: "The Conservatory", completed: true },
          { text: "The PH", completed: true },
        ],
      },
    },

    {
      sectionTitle: "Arrivals",
      value: {
        items: [
          {
            text: "The Nest (Bifani, Tracey)",
            completed: true,
          },
          {
            text: "Guided Check-In | 4pm",
            completed: true,
          },
          {
            text: "Higher Dose PEMF Mat & Red Light Mask",
            completed: true,
          },
          {
            text: "2 Firm Pillows",
            completed: true,
          },

          {
            text: "Self Check-In | 4pm",
            completed: true,
          },
          {
            text: "Place Whole Milk In Room",
            completed: true,
          },
          {
            text: "Feather Allergy | Hypoallergenic Room",
            completed: true,
          },
          {
            text: "She's okay with Room Spray",
            completed: true,
          },
          {
            text: "Midstay | Yes 2.01",
            completed: true,
          },
          {
            text: "Parking | No",
            completed: true,
          },
        ],
      },
    },

    {
      sectionTitle: "Turnovers",
      value: {
        items: [
          { text: "The Nest", completed: true },
          { text: "The Nook", completed: true },
          { text: "The Hideaway", completed: true },
        ],
      },
    },

    {
      sectionTitle: "Midstays",
      value: {
        items: [
          {
            text: "The Den | Knocked door, no answer",
            completed: true,
          },
          {
            text: "The Nomad | No response",
            completed: true,
          },
          {
            text: "The Wing | 11:30 AM Midstay",
            completed: true,
          },
          {
            text: "Study | Bugs and wobbly toilet",
            completed: true,
          },
        ],
      },
    },

    {
      sectionTitle: "Stayovers",
      value: {
        items: [
          {
            text: "The Bunk | Received one yesterday",
            completed: true,
          },
          {
            text: "The Cafe | Req. 2.01",
            completed: true,
          },
        ],
      },
    },

    {
      sectionTitle: "Vacant Rooms / Status",
      value: {
        items: [
          {
            text: "The SS | VD",
            completed: true,
          },
        ],
      },
    },

    {
      sectionTitle: "OTA",
      value: {
        items: [
          {
            text: "NONE",
            completed: true,
          },
        ],
      },
    },

    {
      sectionTitle: "Assigned Paid",
      value: {
        items: [
          {
            text: "NONE",
            completed: true,
          },
        ],
      },
    },

    {
      sectionTitle: "Validation Quantity",
      value: {
        items: [
          {
            text: "NONE",
            completed: true,
          },
        ],
      },
    },

    {
      sectionTitle: "Guest Name",
      value: {
        value: `Lowe, Kim, Bifani, Tracey`,
      },
    },

    {
      sectionTitle: "Room Name",
      value: {
        value: `The Nook & The Nest`,
      },
    },

    {
      sectionTitle: "Event / Group Name",
      value: {
        value: "Orli Happy Hour",
      },
    },

    {
      sectionTitle: "Event Time & Date",
      value: {
        value: "2026-01-30",
      },
    },

    {
      sectionTitle: "Event Details",
      value: {
        value: "Complimentary June Shine + BTL Service for purchase",
      },
    },

    {
      sectionTitle: "Tasks",
      value: {
        items: [
          "Pick Up & Put Out Pastries",
          "Check Hello@stayorli.com Email",
          "Set up Bloom",
          "Set Up Remarkable Pro Pad",
          "Check Concierge for Unfulfilled Requests",
          "Ask The Wing when they'd like the PEMF Mat Delivered",
          "Send Travel & Leisure Canned Msg",
          "Apple TV Serial Number",
          "Put Blocks on Open Rooms @ 6:30pm",
        ],
      },
    },

    {
      sectionTitle: "AM Pass Down",
      value: {
        items: [
          "Bloomy set out + desk decor",
          "Parties placed in lounge",
          "Music turned on",
          "HSKP List made and delivered",
          "Midstay messages sent out",
          "Travel + Leisure sent out to Hideaway",
          "Went through departures and balanced bills",
          "Went through arrivals and balanced bills",
          "Checked all Lynx codes",
          "PCI's sent out 72 hours",
          "Duve messages closed out",
          "Laundry disposable bags ordered",
        ],
      },
    },
    {
      sectionTitle: "PM Pass Down",
      value: {},
    },
  ],
};

export const DUMMY_OPERATIONS_TEMPLATES = [
  {
    _id: "template_1",
    templateName: "Orli Shift Summary",
    heading: "ORLI SHIFT SUMMARY",
    description:
      "Daily operational shift summary used for front desk and hotel operations handoff.",
    sections: [
      {
        order: 1,
        title: "Departures",
        subheading: "Guests scheduled to depart today",
        fieldType: "checkbox_list",
      },
      {
        order: 2,
        title: "Arrivals",
        subheading: "Guests arriving today",
        fieldType: "checkbox_list",
      },
      {
        order: 3,
        title: "Turnovers",
        subheading: "Rooms requiring turnover",
        fieldType: "checkbox_list",
      },
      {
        order: 4,
        title: "Midstays",
        subheading: "Midstay guest activities",
        fieldType: "checkbox_list",
      },
      {
        order: 5,
        title: "Stayovers",
        subheading: "Guests remaining in-house",
        fieldType: "checkbox_list",
      },
      {
        order: 6,
        title: "Vacant Rooms / Status",
        subheading: "Track vacant room inventory",
        fieldType: "checkbox_list",
      },
      {
        order: 7,
        title: "OTA",
        subheading: "OTA booking information",
        fieldType: "checkbox_list",
      },
      {
        order: 8,
        title: "Assigned Paid",
        subheading: "Parking assignments",
        fieldType: "checkbox_list",
      },
      {
        order: 9,
        title: "Validation Quantity",
        subheading: "Parking validations issued",
        fieldType: "checkbox_list",
      },
      {
        order: 10,
        title: "Guest Name",
        subheading: "Amenity recipient",
        fieldType: "text_input",
      },
      {
        order: 11,
        title: "Room Name",
        subheading: "Amenity destination room",
        fieldType: "text_input",
      },
      {
        order: 12,
        title: "Guest Amenity",
        subheading: "Amenity details",
        fieldType: "bullet_point_list",
      },
      {
        order: 13,
        title: "Event / Group Name",
        subheading: "Upcoming events and groups",
        fieldType: "text_input",
      },
      {
        order: 14,
        title: "Event Time & Date",
        subheading: "Event schedule",
        fieldType: "date_field",
      },
      {
        order: 15,
        title: "Event Details",
        subheading: "Additional event information",
        fieldType: "text_area",
      },
      {
        order: 16,
        title: "Tasks",
        subheading: "Operational tasks",
        fieldType: "bullet_point_list",
      },
      {
        order: 17,
        title: "Other",
        subheading: "Additional notes",
        fieldType: "text_area",
      },
      {
        order: 18,
        title: "AM Pass Down",
        subheading: "Morning shift handoff notes",
        fieldType: "bullet_point_list",
      },
      {
        order: 19,
        title: "PM Pass Down",
        subheading: "Evening shift handoff notes",
        fieldType: "bullet_point_list",
      },
    ],
  },

  {
    _id: "template_2",
    templateName: "Housekeeping Daily Board",
    heading: "HOUSEKEEPING DAILY BOARD",
    description: "Daily housekeeping checklist and passdown workspace.",
    sections: [
      {
        order: 1,
        title: "Rooms To Clean",
        subheading: "Rooms assigned for cleaning today",
        fieldType: "checkbox_list",
      },
      {
        order: 2,
        title: "Maintenance Flags",
        subheading: "Issues noticed during cleaning",
        fieldType: "bullet_point_list",
      },
      {
        order: 3,
        title: "Housekeeping Notes",
        subheading: "General housekeeping notes",
        fieldType: "text_area",
      },
    ],
  },

  {
    _id: "template_3",
    templateName: "Maintenance Daily Log",
    heading: "MAINTENANCE DAILY LOG",
    description: "Daily maintenance tasks, issues, and completion tracking.",
    sections: [
      {
        order: 1,
        title: "Open Maintenance Tasks",
        subheading: "Tasks that need attention today",
        fieldType: "checkbox_list",
      },
      {
        order: 2,
        title: "Parts Needed",
        subheading: "Parts or supplies required",
        fieldType: "bullet_point_list",
      },
      {
        order: 3,
        title: "Maintenance Notes",
        subheading: "Additional maintenance notes",
        fieldType: "text_area",
      },
      {
        order: 4,
        title: "Follow Up Date",
        subheading: "Next required follow-up",
        fieldType: "date_field",
      },
    ],
  },
];
